import { render, staticRenderFns } from "./goodsTag.vue?vue&type=template&id=1a0b9918&scoped=true"
import script from "./goodsTag.vue?vue&type=script&lang=js"
export * from "./goodsTag.vue?vue&type=script&lang=js"
import style0 from "./goodsTag.vue?vue&type=style&index=0&id=1a0b9918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b9918",
  null
  
)

export default component.exports